import React from "react";

const PdfSubHeadingText = ({ heading, content }) => {
  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <p
        style={{
          fontSize: "15px",
          display: "flex",
          justifyContent: "space-between",
          width: "50%",
          
        }}
      >
        <span>{heading}</span>
        <span style={{ fontWeight: "600" }}>:</span>
      </p>
      <h3
        style={{
          fontSize: "13px",
          width: "50%",
          marginLeft:"5px"
        }}
      >
        {content}
      </h3>
    </div>
  );
};

export default PdfSubHeadingText;
